import axiosClient from "../apiClient";

export const getDashboardData = () => {
  return axiosClient.get("admin/dashboard?type=year");
};
